<style scoped>
.loader-block {
  margin-top: 100px;
  width: 100%;
}

.empty-list-msg {
  text-align: center;
  padding: 20px 0;
}

.notification_add {
  text-align: center;
  margin: 30px 0;
}
</style>

<template>
<div class="notification-page col-12 row">
  <div class="loader-block" v-if="ifLoader">
    <loader-component></loader-component>
  </div>
  <div class="data-block" v-if="!ifLoader">
    <div class="col-12 row input-setting-block">
      <div class="offset-1 col-1">
        <input  id="all-notification"
                v-model="all_notification_status" type="checkbox" autocomplete="off">
        <label for="all-notification">.</label>
      </div>
      <div class="col-9 item-name">
        <p>Разрешить все оповещения </p>
      </div>
      <div class="offset-2 col-8 text-info-after-all-notification-block">
        <p>Запрет оповещений приведет к невозможности оповестить пользователя о тревоге в момент ее возникновения</p>
      </div>
    </div>
    <div class="col-12 row">
      <div v-if="issetNotificationUtlizers">
        <notification-utilizer-component v-for="(notification, index) in getNotificationUtlizersList" :index="index" :key="index"
            v-on:deleteRow="deleteRow(index)"
            v-bind="notification"></notification-utilizer-component>
      </div>
      <div class="col-12 empty-list-msg" v-else>
        <p>Список уведомляемых пуст</p>
      </div>
    </div>
    <div class="col-md-12 notification_add">
      <a class="aquazor-btn" @click="createNotificationUtilizer">Добавить контакт для уведомления</a>
    </div>
  </div>
</div>
</template>

<script>
import msg from './elements/msg.vue'
import axios from 'axios'
import config from '@/config.js'
import notificationUtilizer from './elements/notification-utilizer'
import loader from './elements/loader.vue'
import {
  store
} from '@/store'

export default {
  created() {
    loadGlobalNotificationStatus(this)
    loadNotificationUsers(this)
  },
  components: {
    'loader-component': loader,
    'msg-component': msg,
    'notification-utilizer-component': notificationUtilizer
  },
  data() {
    return {
      loader: true,
      all_notification_status: null,
      notification_utlizers_list: null
    }
  },
  computed: {
    ifLoader: function () {
      if (this.all_notification_status == null) {
        return true
      } else {
        return false
      }
    },
    getNotificationUtlizersList: function () {
      if (!!this.notification_utlizers_list && this.notification_utlizers_list.length > 0) {
        return this.notification_utlizers_list
      } else {
        return []
      }
    },
    issetNotificationUtlizers: function () {
      return (!!this.notification_utlizers_list && this.notification_utlizers_list.length > 0)
    }
  },
  watch: {
    all_notification_status: function (this_all_notification_status, old_all_notification_status) {
      if (old_all_notification_status != null && this_all_notification_status != old_all_notification_status) {
        changeGlobalNotificationStatus(this_all_notification_status, this)
      }
    }
  },
  methods: {
    createNotificationUtilizer: function () {
      this.notification_utlizers_list.push({
        id_utilizer: null,
        name: '',
        mail: '',
        mail_status: false,
        tel: '',
        tel_status: false
      })
    },
    deleteRow: function (index_row) {
      this.notification_utlizers_list.splice(index_row, 1)
    }
  },
}

function loadGlobalNotificationStatus(vue_obj) {
  var post_data = new FormData()
  post_data.set('token', localStorage.token)
  post_data.set('id_group', vue_obj.$route.params.id_group)

  axios({
      method: 'POST',
      url: config.API_HOST + '/notifications/get_global_status',
      data: post_data
    })
    .then(function (request) {
      if (typeof request.data.notification_global_status != "undefined") {
        vue_obj.all_notification_status = request.data.notification_global_status
      }
    })
    .catch(function (error) {
      console.log(error)
    })
}

function loadNotificationUsers(vue_obj) {
  var post_data = new FormData()
  post_data.set('token', localStorage.token)
  post_data.set('id_group', vue_obj.$route.params.id_group)

  axios({
      method: 'POST',
      url: config.API_HOST + '/notifications/list_notifications',
      data: post_data
    })
    .then(function (request) {
      if (typeof request.data.notification_utilizers != "undefined") {
        vue_obj.notification_utlizers_list = request.data.notification_utilizers
      }
    })
    .catch(function (error) {
      console.log(error)
    })
}

function changeGlobalNotificationStatus(notification_global_status, vue_obj) {
  var post_data = new FormData()
  post_data.set('token', localStorage.token)
  post_data.set('id_group', vue_obj.$route.params.id_group)
  post_data.set('notification_global_status', notification_global_status)

  axios({
      method: 'POST',
      url: config.API_HOST + '/notifications/change_global_status',
      data: post_data
    })
    .then(function (request) {
      console.log(request)
    })
    .catch(function (error) {
      console.log(error)
    })
}
</script>



// WEBPACK FOOTER //
// src/components/notification_users.vue